import { render, staticRenderFns } from "./CompanyAssetEmails.vue?vue&type=template&id=12a28c13"
import script from "./CompanyAssetEmails.vue?vue&type=script&lang=js"
export * from "./CompanyAssetEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports